export enum CategoryId {
  ID_VERIFICATION = "id-verification",
  INCOME = "income",
  CREDIT_HISTORY = "credit-history",
  RENTAL_HISTORY = "rental-history",
  CRIMINAL_HISTORY = "criminal-history",
}

/**
 * Configuration for category groups displayed in the UI
 */
export const categoryGroups = [
  {
    id: CategoryId.ID_VERIFICATION,
    name: "ID Verification",
  },
  {
    id: CategoryId.INCOME,
    name: "Income",
  },
  {
    id: CategoryId.CREDIT_HISTORY,
    name: "Credit History",
  },
  {
    id: CategoryId.RENTAL_HISTORY,
    name: "Rental History",
  },
  {
    id: CategoryId.CRIMINAL_HISTORY,
    name: "Criminal History",
  },
];

export const backgroundCheckCategories = [
  CategoryId.CREDIT_HISTORY,
  CategoryId.RENTAL_HISTORY,
  CategoryId.CRIMINAL_HISTORY,
];

export const identityVerificationCategories = [CategoryId.ID_VERIFICATION];

/**
 * Base label templates by category and status
 */
export const labelTemplates = {
  id: {
    fail: "ID Verification Issues",
    warn: "ID Verification Issues",
    pass: "ID Accepted",
  },
  income: {
    fail: "Income Issues",
    warn: "Income could not be verified",
    pass: "Income Verified", // This will typically be overridden with ratio info
  },
  credit: {
    fail: "Credit Issues",
    warn: "Credit Warning", // Often overridden with score
    pass: "No Issues", // Often overridden with score
  },
  rental: {
    fail: "Rental History Issues",
    warn: "Rental History Warning",
    pass: "No Issues",
  },
  criminal: {
    fail: "Criminal History",
    warn: "Criminal History",
    pass: "No Issues",
  },
};

/**
 * Define which statuses qualify for outcome-based labels by category
 */
export const qualifyingStatuses = {
  rental: ["fail", "warn"],
  credit: ["fail", "warn"],
  criminal: ["warn"],
};

/**
 * Define issue detectors for different categories
 * Each detector has keywords to search for in title/description and the label to show
 */
export const issueDetectors = {
  identity: [{ keywords: ["identity"], label: "ID Verification" }],
  income: [{ keywords: ["income"], label: "Income" }],
  rental: [
    { keywords: ["rental", "collection"], label: "Rental Collections" },
    { keywords: ["eviction"], label: "Evictions" },
  ],
  credit: [
    { keywords: ["credit", "bankrupt"], label: "Bankruptcies" },
    { keywords: ["credit", "collection"], label: "Collections" },
    { keywords: ["foreclosure"], label: "Foreclosures" },
    {
      keywords: ["credit", "thin"],
      label: "Thin Credit File",
    },
    { keywords: ["credit", "score"], label: "Low Credit Score" },
  ],
  criminal: [
    { keywords: ["criminal"], label: "Criminal Records" },
    { keywords: ["felonies"], label: "Felonies" },
  ],
  background: [
    { keywords: ["background-reports-run"], label: "No Background Report" },
  ],
};

export const CATEGORY_ENDPOINTS = {
  [CategoryId.ID_VERIFICATION]: "verifications",
  [CategoryId.INCOME]: "income-and-assets-verification",
  [CategoryId.CREDIT_HISTORY]: "credit-and-background-check",
  [CategoryId.RENTAL_HISTORY]: "credit-and-background-check",
  [CategoryId.CRIMINAL_HISTORY]: "credit-and-background-check",
};
